<template>
  <el-container class="indexhome">
    <el-header>
      <img
        class="logo"
        src="../assets/logo.svg">
      <!-- <p>{{$t('global.parentTitle')}}</p> -->
    </el-header>
    <div class="index_tishi">
       <span > {{tishi}} </span>
    </div>
    <el-main>
      <!-- 登录 -->
      <div class="login_form">
        <!-- <div class="form_list"> -->
        <el-form :model="ruleForm" :rules="signValidate"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <h3>{{$t('signIn.signIn')}}</h3>
          <h4>{{$t('signIn.enterInfo')}}</h4>
          <p style="text-align:center">{{$t('signIn.sentCode')}}</p>
          <p style="margin-top:25px;">{{$t('signIn.phone')}}</p>
          <div class="phone_form">
            <!-- <el-select v-model="ruleForm.areaCode" placeholder="+86">
              <el-option
                v-for="item in qvhao"
                :key="item.id"
                :label="'+' + item.country_code"
                :value="item.country_code"
              >
              </el-option>
            </el-select> -->
            <!-- <el-select v-model="ruleForm.areaCode" filterable placeholder="+ 86">
              <el-option
                v-for="item in qvhao"
                :key="item.id"
                :label="item.title + '  +' + item.country_code"
                :value="item.country_code">
              </el-option>
            </el-select> -->
            <el-select v-model="ruleForm.areaCode" collapse-tags @change="changeCode" >
              <div class="el-input_search">
                <img src="../assets/search.svg" /><input type="text" :placeholder="$t('signIn.searchArea')" class="el-input__inner" v-model="dropDownValue" @keyup="dropDownSearch">
              </div>
              <el-option v-for="item in areaCodeData"
                :key="item.id"
                :label="'+' + item.country_code+' '+item.title"
                :value="item.id"> +{{item.country_code}} {{item.title}}</el-option>
            </el-select>
            <!-- <input class="phone" type="text" v-model="ruleForm.phone" autocomplete="off" maxlength="11"/> -->
          <el-form-item prop="phone">
            <el-input  oninput="value=value.replace(/\D/gi,'')" :class="changeFlag == 1?'phone':'errorPass'" class="phone" type="text" v-model="ruleForm.phone" autocomplete="off" :maxlength="max"></el-input>
          </el-form-item>
          </div>
          <p>{{$t('signIn.password')}}</p>
          <el-form-item prop="password">
            <el-input :class="changeLoginFlag == 1?'pass':'errorPass'" :type="ruleForm.pwdType" v-model="ruleForm.password" autocomplete="off"></el-input>
            <img :src="ruleForm.seen?openeye:nopeneye" class="eye" alt="" @click="changeType(ruleForm.seen)">
          </el-form-item>
          <span
            class="huo"
            @click="forgetPass"
            >{{$t('signIn.forgetPassword')}}</span>
          <el-button type="primary" class="delu" @click="submitForm()">{{$t('signIn.signIn')}}</el-button>
          <span
            class="huo"
            @click="toVeriCode"
            >{{$t('signIn.signIncode')}}</span>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
export default {
  name: 'loginPassword',
  data () {
    // 手机号验证
    const loginCheck = async (rule, value, callback) => {
      let reg = /^\d{1,}$/
      if (value.length < 1) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.phoneEmpty')))
      } else if (!reg.test(value)) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.phoneError')))
      } else {
        this.changeFlag = 1
        callback()
      }
    }
    // 密码验证
    const pwdCheck = async (rule, value, callback) => {
      // let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@#$%\*-\+=:,\\?\[\]\{}]).{8,}$/;
      // let reg = /^[0-9a-zA-Z]{8,}$/;
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeLoginFlag = 2
        return callback(new Error(this.$t('errorprompt.passwordEmpty')))
      } else if (value.length < 8) {
        this.changeLoginFlag = 2
        return callback(new Error(this.$t('errorprompt.passwordLessThan')))
      } else if (!reg.test(value)) {
        this.changeLoginFlag = 2
        return callback(new Error(this.$t('errorprompt.passwordLessThan')))
      } else {
        this.changeLoginFlag = 1
        callback()
      }
    }
    return {
      qvhao: [],
      areaCodeData: [],
      dropDownValue: '',
      valueMeta: [],
      ruleForm: {
        phone: '',
        password: '',
        areaCode: '',
        pwdType: 'password',
        seen: false,
        code:''
      },
      resetForm: {
        newPassword: '',
        ConfirmNewPassword: '',
        NewSeen: false,
        confirmNewSeen: false,
        newPwdType: 'password',
        confirmNewPwdType: 'password'
      },
      signValidate: {
        phone: [
          { required: true, validator: loginCheck, trigger: 'blur' },
          { min: 6, message: this.$t('errorprompt.phoneError'), trigger: 'blur' },
        ],
        password: [
          { required: true, validator: pwdCheck, trigger: 'blur' }
        ]
      },
      changeFlag: 1,
      changeLoginFlag: 1,
      openeye: require('@/assets/eye.svg'), // 图片地址
      nopeneye: require('@/assets/eye-off.svg'), // 图片地址
      tishi:'',
      max:10
    }
  },
  created () {
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/sinadd'
        })
      } else {
        this.$router.push({
          path: '/home/children/AttendClassNow'
        })
      }
    } else {
      this.$router.push({
        path: '/loginPassword'
      })
    }
    this.areaCodeData = getStore(keys.areaCodeList)
    this.qvhao = getStore(keys.areaCodeList)
    this.ruleForm.areaCode=this.areaCodeData[0].id
    this.ruleForm.code=this.areaCodeData[0].country_code
  },
  mounted(){
    
      var userAgent =navigator.userAgent;
      var Chrome=userAgent.indexOf('Chrome') > -1;
      var Edge =userAgent.indexOf('Edg')>-1;
      if(!(Chrome||Edge)){
        this.tishi='Please make sure you use Google Chrome or Microsoft Edge browser.';
        
      }
  },
  methods: {
    changeCode(){
        this.areaCodeData.map((item) => {
            if(this.ruleForm.areaCode == item.id){
                this.ruleForm.code = item.country_code
            }
        });
        if(this.ruleForm.code=='86'){
			if(this.ruleForm.phone.length>11){
				this.ruleForm.phone = ''
			}
          this.max = 11
		  // this.signValidate.phone[1].min = 1
        }else if(this.ruleForm.code=='1'){
          if(this.ruleForm.phone.length>10){
            this.ruleForm.phone = ''
          }
          this.max = 10
		//  this.signValidate.phone[1].min = 1
        }else{
			// this.signValidate.phone[1].min = 6
			this.max= 15
		}
      },
    dropDownSearch () {
      var _this = this
      if (_this.dropDownValue) {
        _this.areaCodeData = []
        _this.qvhao.find(item => {
          let name =  ' +' + item.country_code +' '+item.title 
          if (name.indexOf(_this.dropDownValue) != -1) {
            _this.areaCodeData.push(item)
          }
        })
      } else {
        _this.areaCodeData = _this.qvhao
      }
    },
    changeType (seen) {
      this.ruleForm.pwdType = this.ruleForm.pwdType === 'password' ? 'text' : 'password'
      this.ruleForm.seen = !seen
    },
    forgetPass () {
      this.$router.push({ path: '/emailFindPsw' })
    },
    toVeriCode () {
      this.$router.push({ path: '/' })
    },
    // 登录
    submitForm () {
      this.$refs.ruleForm.validate((valid, msg) => {
        if (!valid) {
          this.$message(msg['password'][0].message || msg['phone'][0].message)
          return false
        }
        this.$http.post('/api/login', {
          mobile: this.ruleForm.phone,
          password: this.ruleForm.password,
          country_code: this.ruleForm.code,
          time_zone: this.utils.getTimeZoneCity()
        }).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.userInfo, res.data.data)
             setStore(keys.status, res.data.data.status)
            setStore(keys.token,res.data.data.token)
            let time_zone = this.utils.getTimeZoneCity()
            this.$http.get('/api/intercomUser?time_zone='+ time_zone).then((res) => {
              if (res.data.code == 200) {
                setStore(keys.IntercomUser, res.data.data)
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
            setTimeout(() => {
              if (res.data.data.status == 0) {
                this.$router.push({ path: '/email' })
              } else {
                this.$router.push({ path: '/home/children/AttendClassNow' })
              }
            }, 2000)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      })
      // let data = {
      //   mobile:this.ruleForm.phone,
      //   password:this.ruleForm.password,
      //   country_code:this.ruleForm.areaCode
      // }
      // // ?mobile="+this.ruleForm.phone+"&password="+this.ruleForm.password+"&country_code="+this.ruleForm.areaCode
      // this.$http
      // .post("/teacherapi/login",JSON.stringify(data))
      // .then((res) => {
      //   console.log(res.data.data.sn);
      //   this.sn = res.data.sn;
      // });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .indexhome{
    width: 1200px;
    height:auto!important;
    margin:0 auto 0 auto;
  }
  .el-header{
      width: 1200px;
      height:auto!important;
      padding: 20px 0;
      font-family: Sofia Pro-Regular;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      .logo {
        width: 227px;
        height: 50px;
        img{
          width:100%;
          height:100%;
        }
      }
      p {
        width: 227px;
        margin-top:5px;
        text-align: center;
      }
  }
  .index_tishi{
    width:720px;
    height: 28px;
    margin: 0px auto;
    font-family: 'Sofia Pro';
    font-style: normal;
    font-size: 18px;
    line-height: 28px;
    color: #374151;
    align-items: center;
text-align: center;
  }
  .el-main{
    overflow: inherit;
    padding:0;
    h3{
      // font-size: 30px;

      font-size: 36px;


      font-family: Sofia Pro-Bold;
      font-weight: 700;
      color: #353643;
      margin-top:10px;
    }
    h4{
      font-size: 16px;
      font-family: Sofia Pro-Bold;
      font-weight: 700;
      color: #424347;
      // margin-top:30px;
      margin-top: 40px;
    }
    p{
      font-size: 16px;
      font-family: Sofia Pro-Regular;
      color: #424347;
      margin-top:12px;
    }
    .login_form{
      .delu{
            margin: 0px auto;
            margin-top: 75px;
          }
      .el-form {
        /**
          @style:修改前样式.
          width: 100%;
        */
          width: 456px;
          margin: 54px auto;
          position: relative;


          border: 0px solid red;
          display: flex;
          flex-direction: column;
          h3,h4{
            text-align: center;
          }
          .phone_form{
            display: flex;
            margin-bottom: 7px;
            .el-select {
              width: 130px;
              height: 40px;
              background: #fafafa;
              border:none;
              color: #353643;
              /deep/ .el-input{
                height:40px;
                .el-input__inner{
                  width:120px;
                  height: 100%;
                  background: none;
                  border:none;
                  color: #353643;
                  font-family: Sofia Pro-Regular;
                }
                .el-input__suffix{
                  right: 15px;
                }
                .el-select__caret{
                  color: #6e6b7b;
                }
              }
            }
            
            .phone{
              // width:255px;
              // padding-left:10px;
              border:none;
              background: none;
              font-size: 16px;
              border-bottom: 1px solid #a5a5a5;
              color: #353643;
              font-family: Sofia Pro-Regular;
              letter-spacing: 0px;
            }
          }
          /deep/ .el-form-item{
              .el-form-item__content{
                display: flex;
                margin:0!important;
                // width: 180px;
                img{
                  width: 20px;
                  height:20px;
                  margin: 0 8px;
                  position: absolute;
                  right: 0px;
                  bottom:12px;
                }
                .el-input{
                  border-bottom: 1px solid #a5a5a5;
                }
                .errorPass{
                  border-bottom: 1px solid #fc424c;
                }
                .el-input__inner {
                  -moz-appearance: none;
                  width:100%;
                  height: 40px;
                  border:none;
                  background: none;
                  font-size: 16px;
                  color: #353643;
                  font-family: Sofia Pro-Regular;
                  letter-spacing: 0px;
                  outline: 0;
                  // padding:0 40px 0 0;
                  border-radius: 0;
                  // border: 1px solid red;
                  padding: 0 !important;
                  text-align: center !important;
                }
                .el-form-item__error{
                  // margin-top:7px;
                  font-size: 14px;
                  color: #fc424c;
                  font-family: Sofia Pro-Regular;
                  width: max-content;
                }
              }
            }

        .input-box {
          .input-content {
            width: 302px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            input {
              color: inherit;
              font-family: Sofia Pro-Regular;
              border: 0;
              outline: 0;
              border-bottom: 1px solid #a5a5a5;
              height: 40px;
              width: 40px;
              // font-size: 28px;
              font-size: 18px;
              text-align: center;
            }
          }

          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            appearance: none;
            margin: 0;
          }
        }
          .huo {
            font-size: 16px;
            font-family: Sofia Pro-Bold;
            font-weight: 700;
            text-decoration: underline;
            // text-align: LEFT;
            color: #ff6440;
            cursor: pointer;
            margin-top:20px;
            // display: contents;
            display: block;
            text-align: center;
          }
          button{
            width: 310px;
            // width: 190px;
            // height: 40px;
            height: 50px;
            background: #4B69FE;
            border-radius: 4px;
            border: 1px solid #4B69FE;
            // margin-top: 40px;
            margin-top: 75px;
            // margin-bottom: 15px;
            color: #fff;
            font-size: 18px;
            font-family: Sofia Pro-Bold;
            box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
            border-radius: 50px;
          }
          .borderBtn{
                margin-top: -11px;
                margin-left: 35px;
              // width:auto;
              // height: 40px;
              // background: #ffffff;
              // border: 2px solid #ff6440;
              // border-radius: 7px;
              // font-size: 14px;
              // font-family: Sofia Pro-Bold;
              font-weight: 700;
              // color: #ff6440;
              // margin: 0 20px;
                // width: 85px;
                height: 50px;
                // position: absolute;
                // left: 875px;
                bottom: 487px;
                color: #000000;
                border: 1.5px solid #000000;
                box-sizing: border-box;
                border-radius: 50px;
                background: #ffffff;
                box-shadow: none;
              &:hover{
                // background: #ffffff;
                // border: 2px solid #ff6440;
                // font-size: 14px;
                font-family: Sofia Pro-Bold;
                // font-weight: 700;
                // color: #ff6440;
              }
          }
          input{
            width:345px;
            height: 50px;
            border:none;
            background: none;
            font-size: 18px;
            color: #353643;
            font-family: Sofia Pro-Regular;
            letter-spacing: 0px;
          }
          input:focus {
            outline: none;
          }
      }
    }
  }

.el-select-dropdown__item.selected{
  color: #409EFF !important;
    font-weight: 700 !important;
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
background: #ffffff;
    color: #409EFF;
    font-weight: bold;
}
.el-main .login_form .el-form .phone_form .el-select{
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/loginPassword.vue